import { render } from "./MEMBER_TURNED_INDEPENDENT.vue?vue&type=template&id=2c85b9ec"
import script from "./MEMBER_TURNED_INDEPENDENT.vue?vue&type=script&lang=js"
export * from "./MEMBER_TURNED_INDEPENDENT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__